import React from "react";
import Typography from "@material-ui/core/Typography";
import MaterialTable from "material-table";
import tableicons from "../tableicons";
import Grid from "@material-ui/core/Grid";
import TextField from "@material-ui/core/TextField";
import DialogActions from "@material-ui/core/DialogActions";
import Button from "@material-ui/core/Button";
import {KeyboardDatePicker, MuiPickersUtilsProvider} from "@material-ui/pickers";
import es from "date-fns/locale/es";
import DateFnsUtils from "@date-io/date-fns";
import DialogRestaurarConteoEliminado from "../components/DialogRestaurarConteoEliminado";
import NumberFormat from "react-number-format";
import DeleteIcon from "@material-ui/icons/Delete";
import EditIcon from '@material-ui/icons/Edit';
import {ajustesResources, tagResources} from "../endpoints";
import CheckIcon from "@material-ui/icons/Check";
import RestoreFromTrashIcon from '@material-ui/icons/RestoreFromTrash';
import SvgIcon from "@material-ui/core/SvgIcon";
import DialogEditarCantidadConteo from "../components/DialogEditarCantidadConteo";
import SnackbarAlert from "../components/SnackbarAlert";
import DialogEliminarConteo from "../components/DialogEliminarConteo";
import Dialog from "@material-ui/core/Dialog";
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogContent from "@material-ui/core/DialogContent";

function NumberFormatCustom(props) {
    const { inputRef, onChange, ...other } = props;

    return (
        <NumberFormat
            {...other}
            getInputRef={inputRef}
            onValueChange={(values) => {
                onChange({
                    target: {
                        name: props.name,
                        value: values.value,
                    },
                });
            }}
            isNumericString
            prefix=""
        />
    );
}

class DetalleDescargaTag extends React.Component{
    constructor(props) {
        super(props);
        this.state={
            tag: props.match.params.tag,
            id_archivo: props.match.params.id_archivo,
            value:0,
            datos:[],
            editar_cantidad: false,
            datos_conteo: "",
            tipo:"desagrupado",
            openSnack:false,
            severity: '',
            message:'',
            eliminar_conteo:false,
            editar_datos:false,
            selectedDate: new Date(),
            hu_1: '',
            nivel:'',
            restaurar:false,
            cargando:true
        }
    }

    handleDateChange = (date) => {
        this.setState({selectedDate: date});
    };

    detalleDescargaTag = () =>{
        tagResources.consultarDescargaTag(this.state.tag,this.state.id_archivo).then(async response => {
            if (response) {
                return await response.json();
            }
        }).then(result => {
            if(result.status_code === 200){
                this.setState({cargando:false,datos:result.consulta})
            }
            else if (result.status_code === 401){
                this.setState({openSnack:true,cargando:false, severity:result.severity, message:result.message})
            }
            else{
                throw new Error('Something went wrong ...');
            }
        }).catch(error=> {
            console.log(error)
        });
    }

    enviar_datos_conteo = (rowData) =>{
        this.setState({editar_cantidad:true, datos_conteo:rowData})
    }

    para_editar_datos = (rowData) =>{
        if(rowData.fecha_vencimiento !== null){
            let date = new Date(rowData.fecha_vencimiento);
            const date2 = new Date(date.getTime() + date.getTimezoneOffset() * 60000)
            this.setState({editar_datos:true,datos_conteo:rowData,selectedDate:date2,nivel:rowData.nivel})
        }
        else{
            const date2 = null
            this.setState({editar_datos:true,datos_conteo:rowData,selectedDate:date2,nivel:rowData.nivel})
        }

        if(rowData.hu === null){
            this.setState({hu_1: ''})
        }
        else{
            this.setState({hu_1:rowData.hu})
        }
    }

    handleClose = () =>{
        this.setState({editar_cantidad:false,eliminar_conteo:false, editar_datos:false, restaurar:false})
    }

    refrescar = (estado,severity) =>{
        this.setState({editar_cantidad:false,eliminar_conteo: false, restaurar:false, openSnack:false, severity: null, message:null}, ()=>{
            if(severity === "success"){
                this.detalleDescargaTag()
            }
            // pequeño delay para reabrir el snack
            setTimeout(() => {
                this.setState({
                    openSnack: true,
                    severity: severity,
                    message: estado,
                });
            }, 50);
        })
    }

    para_eliminar = (row) =>{
        this.setState({eliminar_conteo:true, datos_conteo:row})
    }

    editarDatos = () =>{
        this.setState({openSnack:false, severity: null, message:null})
        const datosConteo={
            hu: this.state.hu_1,
            nivel: this.state.nivel,
            fecha_vencimiento: this.state.selectedDate
        }
        ajustesResources.ajustarDatos(this.state.datos_conteo.id,datosConteo).then(async response => {
            if (response) {
                return await response.json();
            }
        }).then(result => {
            if(result.message){
                this.setState({editar_datos:false, openSnack:true, severity:result.severity, message:result.message})
                this.detalleDescargaTag()
            }
            else{
                throw new Error('Something went wrong ...');
            }
        }).catch(error=> {
            console.log(error)
            this.setState({editar_datos:false, openSnack:true, severity:"error", message:"Ha ocurrido un error inesperado"})
        });
    }

    paraRestaurar = (row) =>{
        this.setState({restaurar:true, datos_conteo:row})
    }

    componentDidMount() {
        this.detalleDescargaTag()
    }

    handleChange = e =>{
        this.setState({[e.target.name]: e.target.value});
    }

    render() {
        return(
            <div>
                <Typography variant="h4" gutterBottom>Detalle ampliado descarga N° {this.state.id_archivo} del tag: {this.state.tag}</Typography>

                <MaterialTable
                    localization={{
                        toolbar: {
                            searchPlaceholder: 'Buscar'
                        },
                        header: {
                            actions: 'Acciones'
                        },
                        body:{
                            emptyDataSourceMessage: 'No hay datos para mostrar'
                        }
                    }}
                    isLoading={this.state.cargando}
                    options={{
                        pageSize: 50,
                        pageSizeOptions: [10, 25, 50, 100],
                        actionsColumnIndex: -1,
                        rowStyle: rowData => ({
                            backgroundColor: (this.state.selectedRow === rowData.tableData.id) ? '#dbe9fc' : '#FFF'
                        }),
                        searchFieldStyle: {
                            width: "auto",
                        },
                        padding: "dense"
                    }}
                    icons={tableicons}
                    title={""}
                    data={this.state.datos}
                    columns={[
                        { title: 'Cód. escan.', field: 'codigo' },
                        { title: 'Cód. tipo', field: 'codigo_tipo'},
                        { title: 'Descripción', field: 'descripcion', cellStyle: {
                                width: 300,
                                maxWidth: 400,
                            },
                            headerStyle: {
                                width: 300,
                                maxWidth: 500
                        }},
                        { title: 'Cantidad capt.', field: 'cantidad'},
                        { title: 'UM', field: 'um'},
                        { title: 'Factor', field: 'factor'},
                        { title: 'Fecha venc.', field: 'fecha_vencimiento',
                            //render: rowData => (rowData.fecha_vencimiento ? rowData.fecha_vencimiento.split('-').reverse().join("-"): null),
                            render: rowData => (rowData.fecha_vencimiento ? (rowData.fecha_vencimiento === "1970-01-01" ? null : rowData.fecha_vencimiento.split('-').reverse().join("-")) : null),
                        },
                        { title: 'HU', field: 'hu'},
                        { title: 'Nivel', field: 'nivel'},
                        { title: 'Cód. Usuario', field: 'usuario' },
                        { title: 'Fecha y hora', field: 'timestamp',
                            render: rowData => new Date(Date.parse(new Date(rowData.timestamp) + ' UTC')).toLocaleString(),
                            customFilterAndSearch: ((term, rowData) => new Date(Date.parse(new Date(rowData.timestamp) + ' UTC')).toLocaleString().indexOf(term) !== -1),
                            cellStyle: {
                                width: 250,
                                maxWidth: 250,
                            },
                            headerStyle: {
                                width: 250,
                                maxWidth: 250
                            }},
                        { title: 'Modificado', field: 'modificado',
                            render: rowData => (rowData.modificado ? <CheckIcon/> : null),
                        },
                        { title: 'Eliminado', field: 'eliminado',
                            render: rowData => (rowData.eliminado ? <CheckIcon/> : null),
                        },
                    ]}
                    actions={[
                        {
                            icon:  () => <EditIcon style={{fontSize:27, margin:4}}/>,
                            tooltip: 'Editar cantidad conteo',
                            onClick: (event, rowData) => this.enviar_datos_conteo(rowData),
                        },
                        {
                            icon:  () =>
                                <SvgIcon style={{fontSize:27, margin:4}}>
                                    <path fill="currentColor" d="M2,6V8H14V6H2M2,10V12H14V10H2M20.04,10.13C19.9,10.13 19.76,10.19 19.65,10.3L18.65,11.3L20.7,13.35L21.7,12.35C21.92,12.14 21.92,11.79 21.7,11.58L20.42,10.3C20.31,10.19 20.18,10.13 20.04,10.13M18.07,11.88L12,17.94V20H14.06L20.12,13.93L18.07,11.88M2,14V16H10V14H2Z" />
                                </SvgIcon>,
                            tooltip: 'Editar otros datos conteo',
                            onClick: (event, rowData) => this.para_editar_datos(rowData),
                        },
                        rowData => ({
                            icon:  () =><DeleteIcon style={{fontSize:27, margin:4}}/>,
                            tooltip: 'Eliminar conteo',
                            onClick: (event, rowData) => this.para_eliminar(rowData),
                            hidden: rowData.eliminado === true}),
                        rowData => ({
                            icon:  () =><RestoreFromTrashIcon style={{fontSize:27, margin:4}}/>,
                            tooltip: 'Reestablecer conteo eliminado',
                            onClick: (event, rowData) => this.paraRestaurar(rowData),
                            hidden: rowData.eliminado === false}),
                    ]}
                    onRowClick={(event, rowData) => this.setState({selectedRow: rowData.tableData.id})}
                />
                {this.state.editar_cantidad && <DialogEditarCantidadConteo origen={"detalle_descarga_tag"} tag={this.state.tag} refrescar={this.refrescar} tipo={this.state.tipo} handleClose={this.handleClose} conteo={this.state.datos_conteo}/>}

                {this.state.eliminar_conteo && <DialogEliminarConteo  refrescar={this.refrescar} tag={this.state.tag} tipo={this.state.tipo} handleClose={this.handleClose} conteo={this.state.datos_conteo}/>}

                {this.state.openSnack? <SnackbarAlert severity={this.state.severity} message={this.state.message}/> : null}

                {this.state.restaurar ? <DialogRestaurarConteoEliminado title={"Restaurar conteo eliminado"} recuperar={"conteo"}  conteo={this.state.datos_conteo} refrescar={this.refrescar}  handleClose={this.handleClose}/>: null}
                <Dialog
                    open={this.state.editar_datos}
                    aria-labelledby="alert-dialog-title"
                    aria-describedby="alert-dialog-description">
                    <DialogTitle id="alert-dialog-title">Modificar cantidad capturada</DialogTitle>
                    <DialogContent>
                        <Grid container spacing={2} alignItems="flex-end">
                            <Grid item xs={12}>
                                Cód. escaneado: {this.state.datos_conteo.codigo}
                            </Grid>
                            <Grid item xs={12}>
                                Material: {this.state.datos_conteo.articulo}
                            </Grid>
                            <Grid item xs={12}>
                                Descripción material: {this.state.datos_conteo.descripcion}
                            </Grid>
                            <Grid item xs={12}>
                                Cantidad actual: {this.state.datos_conteo.cantidad}
                            </Grid>
                            <Grid item xs={12}>
                                <TextField
                                    onChange={this.handleChange}
                                    label="HU"
                                    name="hu_1"
                                    value={this.state.hu_1}
                                    fullWidth
                                />
                            </Grid>
                            <Grid item xs={6}>
                                <TextField
                                    onChange={this.handleChange}
                                    label="Nivel"
                                    name="nivel"
                                    value={this.state.nivel}
                                    fullWidth
                                    InputProps={{
                                        inputComponent: NumberFormatCustom,
                                    }}
                                />
                            </Grid>
                            <Grid item xs={6}>
                                <MuiPickersUtilsProvider locale={es} utils={DateFnsUtils}>
                                    <Grid container>
                                        <KeyboardDatePicker
                                            disableToolbar
                                            variant="inline"
                                            format="dd/MM/yyyy"
                                            id="date-picker-inline"
                                            label="Fecha vencimiento"
                                            value={this.state.selectedDate}
                                            onChange={this.handleDateChange}
                                            KeyboardButtonProps={{
                                                'aria-label': 'change date',
                                            }}
                                        />
                                    </Grid>
                                </MuiPickersUtilsProvider>
                            </Grid>
                        </Grid>
                    </DialogContent>
                    <DialogActions>
                        <Button variant="contained" color="secondary" onClick={this.handleClose}>
                            Cancelar
                        </Button>
                        <Button variant="contained" disabled={!(this.state.hu_1 || this.state.nivel || this.state.selectedDate)} color="primary"  onClick={this.editarDatos}>
                            Guardar
                        </Button>
                    </DialogActions>
                </Dialog>
            </div>
        )
    }
}

export default DetalleDescargaTag;